<template>   
  <div class="skeleton-center-wrapper">
    <VueSkeletonLoader
      type="rect"
      wave-color="#c5d4e7"
      color="#c5d4e7"
      class="skeleton-center"
      animation="fade"
    />
  </div>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue';
export default {
  components: { VueSkeletonLoader },
};
</script>

<style scoped>
.skeleton-center-wrapper {
  width: 100% !important;
  height: 100% !important; /* altura da área total */
  display: flex;
  justify-content: center; 
  align-items: center;
  /* padding: 30px; */
}

.skeleton-center {
  width: 100% !important;
  height: 100% !important;
  border-radius: 50%;
}
</style>
